
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/repository",
      function () {
        return require("private-next-pages/clm/repository/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clm/repository"])
      });
    }
  